module.exports = __webpack_public_path__ + "img/Falu.2.dc3a3180.jpg";